/**
 * Close Wireless Standart integration.
*/
export default function close() {
    return window.WS_CloseForm();
}